<div class="stats-treatments">
  <!-- Performance Chart -->
  <section class="stats-treatments__chart-section">
    <div class="stats-treatments__card">
      <div class="stats-treatments__card-header">
        <h2>
          <i class="pi pi-chart-bar"></i>
          {{ "STATISTICS.TREATMENTS.CHARTS.PERFORMANCE_TITLE" | translate }}
        </h2>
        <span class="stats-treatments__subtitle">{{
          "STATISTICS.TREATMENTS.CHARTS.PERFORMANCE_SUBTITLE" | translate
        }}</span>
      </div>
      <div class="stats-treatments__card-body">
        <app-stat-chart
          type="bar"
          [data]="performanceChartData"
          [options]="performanceChartOptions"
          [loading]="loading"
          [empty]="treatments.length === 0"
          height="400px"
        />
      </div>
    </div>
  </section>

  <!-- Two Column: Bubble + Table Preview -->
  <section class="stats-treatments__two-col">
    <!-- Profitability Matrix -->
    <div class="stats-treatments__card">
      <div class="stats-treatments__card-header">
        <h2>
          <i class="pi pi-chart-scatter"></i>
          {{ "STATISTICS.TREATMENTS.CHARTS.PROFITABILITY_TITLE" | translate }}
        </h2>
        <span class="stats-treatments__subtitle">{{
          "STATISTICS.TREATMENTS.CHARTS.PROFITABILITY_SUBTITLE" | translate
        }}</span>
      </div>
      <div class="stats-treatments__card-body">
        <app-stat-chart
          type="bubble"
          [data]="bubbleChartData"
          [loading]="loading"
          [empty]="treatments.length === 0"
          height="300px"
        />
        <div class="stats-treatments__matrix-legend">
          <div class="stats-treatments__matrix-axis">
            <span>{{ "STATISTICS.TREATMENTS.CHARTS.LESS_PERFORMED" | translate }}</span>
            <span>{{ "STATISTICS.TREATMENTS.CHARTS.MORE_PERFORMED" | translate }}</span>
          </div>
          <p class="stats-treatments__matrix-note">
            {{ "STATISTICS.TREATMENTS.CHARTS.MATRIX_NOTE" | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- Quick Stats -->
    <div class="stats-treatments__card">
      <div class="stats-treatments__card-header">
        <h2>
          <i class="pi pi-info-circle"></i>
          {{ "STATISTICS.TREATMENTS.SUMMARY.TITLE" | translate }}
        </h2>
      </div>
      <div class="stats-treatments__card-body">
        <div class="stats-treatments__summary">
          <div class="stats-treatments__summary-item">
            <span class="stats-treatments__summary-label">{{
              "STATISTICS.TREATMENTS.SUMMARY.TOTAL_TREATMENTS" | translate
            }}</span>
            <span class="stats-treatments__summary-value">{{
              treatments.length
            }}</span>
          </div>
          <div class="stats-treatments__summary-item">
            <span class="stats-treatments__summary-label">{{
              "STATISTICS.TREATMENTS.SUMMARY.MOST_PROFITABLE" | translate
            }}</span>
            <span class="stats-treatments__summary-value">
              {{ treatments[0]?.treatmentName || "-" }}
            </span>
          </div>
          <div class="stats-treatments__summary-item">
            <span class="stats-treatments__summary-label">{{
              "STATISTICS.TREATMENTS.SUMMARY.TOP_1_REVENUE" | translate
            }}</span>
            <span class="stats-treatments__summary-value text-primary">
              {{ formatCurrency(treatments[0]?.revenue || 0) }}
            </span>
          </div>
          <div class="stats-treatments__summary-item">
            <span class="stats-treatments__summary-label">{{
              "STATISTICS.TREATMENTS.SUMMARY.MOST_PERFORMED" | translate
            }}</span>
            <span class="stats-treatments__summary-value">
              {{ getMostPerformedTreatment() }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Full Table -->
  <section class="stats-treatments__table-section">
    <div class="stats-treatments__card">
      <div class="stats-treatments__card-header">
        <h2>
          <i class="pi pi-list"></i>
          {{ "STATISTICS.TREATMENTS.TABLE.TITLE" | translate }}
        </h2>
      </div>
      <div
        class="stats-treatments__card-body stats-treatments__card-body--no-padding"
      >
        <p-table
          [value]="treatments"
          [loading]="loading"
          styleClass="p-datatable-sm p-datatable-striped"
          [scrollable]="true"
          scrollHeight="400px"
          [rowHover]="true"
          [sortField]="'revenue'"
          [sortOrder]="-1"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px">#</th>
              <th pSortableColumn="treatmentName">
                {{ "STATISTICS.TREATMENTS.TABLE.HEADERS.TREATMENT" | translate }}
              </th>
              <th pSortableColumn="categoryName">
                {{ "STATISTICS.TREATMENTS.TABLE.HEADERS.CATEGORY" | translate }}
              </th>
              <th pSortableColumn="count" class="text-right">
                {{ "STATISTICS.TREATMENTS.TABLE.HEADERS.QUANTITY" | translate }}
              </th>
              <th pSortableColumn="averagePrice" class="text-right">
                {{ "STATISTICS.TREATMENTS.TABLE.HEADERS.AVERAGE_PRICE" | translate }}
              </th>
              <th pSortableColumn="revenue" class="text-right">
                {{ "STATISTICS.TREATMENTS.TABLE.HEADERS.REVENUE" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>
                <span class="rank" [class.rank--top3]="i < 3">{{ i + 1 }}</span>
              </td>
              <td class="font-medium">{{ item.treatmentName }}</td>
              <td>
                <span class="category-badge">{{ item.categoryName }}</span>
              </td>
              <td class="text-right">{{ item.count }}</td>
              <td class="text-right">
                {{ formatCurrency(item.averagePrice) }}
              </td>
              <td class="text-right font-semibold text-primary">
                {{ formatCurrency(item.revenue) }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-muted">
                {{ "STATISTICS.TREATMENTS.TABLE.EMPTY" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </section>
</div>
